import * as React from 'react';
import { Component } from 'react';
import { parse } from 'query-string';
import BPromise from 'bluebird';
import propz from 'propz';
import {
  ColumnDefinition,
  getFilters2,
  getOrder,
  getSearchFilter,
  getSearchOrder,
  getServerFieldSectionWhere,
  getServerQueryFilter2,
  isFilterExist2,
  isSortExist,
  TABLE_SORT_DIRECTION
} from 'Src/helpers/table/table';
import { DATE_INTERVAL, FILTER_TYPE, FIRST_PAGE, LIMIT } from 'Src/consts/table';

import { Loader } from 'Src/components/Loader/Loader';
import { ListEmptyState } from 'Src/components/ListEmptyState/ListEmptyState';
import { faTrophy } from '@fortawesome/free-solid-svg-icons';
import { SelectAllCheckbox } from 'Src/components/SelectAllCheckbox/SelectAllCheckbox';
import { AppUser } from 'Src/views/App/App';
import './SchoolLeagues.css';
import { History, Location } from 'history';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import { LeagueNews, LeaguePhoto, SchoolLeague } from 'Src/models/schoolLeague';
import {
  createSchoolLeagues,
  deleteSchoolLeagues,
  getAllSchoolLeagues,
  getSchoolLeagueEvents,
  getSchoolLeagues,
  getSchoolLeaguesCount,
  updateSchoolLeagues
} from 'Src/helpers/service/admin/schoolLeagues';
import { SchoolLeagueForm } from './SchoolLeagueForm/SchoolLeagueForm';
import { getAggregationType } from 'Src/helpers/accessor/accessor';
import { getAllForms } from 'Src/helpers/service/admin/forms';
import { getSelectOptionForAggregationType } from 'Src/helpers/table/select';
import {
  LEAGUE_AGGREGATION_TYPE,
  LEAGUE_AGGREGATION_TYPE_SERVER_TO_CLIENT_MAPPING,
  LEAGUE_TABS
} from 'Src/consts/league';
import { SchoolLeagueSummary } from './SchoolLeagueSummary/SchoolLeagueSummary';
import { TABS } from 'Src/consts/common';
import { SchoolEvent } from 'Src/models/event';
import { SchoolLeagueEventsSummary } from './SchoolLeagueSummary/SchoolLeagueEventsSummary';
import { SchoolLeagueNewsSummary } from './SchoolLeagueNewsSummary/SchoolLeagueNewsSummary';
import { getAllSchoolLeagueNews } from 'Src/helpers/service/admin/schoolLeagueNews';
import { isLeagueHouse, isLeagueIndividual, isLeagueTeam } from '../../../../../helpers/league/league';
import { EVENT_TYPES } from '../../../../../consts/event';
import moment from 'moment';
import { AggregatedTargetCompletionReportForm } from './Reports/AggregatedTargetCompletionReportForm/AggregatedTargetCompletionReportForm';
import { AggregatedTargetCompletionForThePeriodReportForm } from './Reports/AggregatedTargetCompletionForThePeriodReportForm/AggregatedTargetCompletionForThePeriodReportForm';
import { TargetParticipationStatisticsReportForm } from './Reports/TargetParticipationStatisticsReportForm/TargetParticipationStatisticsReportForm';
import { TargetCompletionStatisticsReportForm } from './Reports/TargetCompletionStatisticsReportForm/TargetCompletionStatisticsReportForm';
import { SchoolForm } from 'Src/models/form';
import { AGE_GROUPS_SORTED } from '../../../../../consts/school';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from 'Src/consts/report';
import Lazy from 'lazy.js';
import { sortAges } from 'Src/helpers/event/event';
import { uploadReport } from 'Src/helpers/service/admin/report';

const COLUMNS: ColumnDefinition[] = [
  {
    text: 'Name',
    field: 'name',
    isSort: true,
    type: FILTER_TYPE.TEXT,
    accessor: ['name']
  },
  {
    text: 'Aggregation',
    field: 'aggregationType',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getAggregationType
  }
];

const LeagueIcon = () => (
  <svg className="schoolLeaguesPage__leagueIcon" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M4 20v-6h5v6M9 20V8h6v12M15 20v-9h5v9M3 20h18" />
  </svg>
);

interface Props {
  user: AppUser;
  history: History;
  location: Location;
}

interface State {
  items: SchoolLeague[];
  currentPage: number;
  selectedItems: SchoolLeague[];
  viewedLeague: SchoolLeague | null;
  editingLeague: SchoolLeague | null;
  sortDirection: TABLE_SORT_DIRECTION;
  sortColumnsName: string;
  isShowFilter: boolean;
  isDataFiltered: boolean;
  filters: any;
  isLoading: boolean;
  isSelectAllChecked: boolean;
  total: number;
  basePath: string;
  currentTabIndex: number;
  leagueId: string;
  isErrorModalOpen: boolean;
  errorMessage: string;
  isEditLeaguePopupOpened: boolean;
  isDeleteLeagueModalOpen: boolean;

  leaguePhotos: LeaguePhoto[];
  leagueEvents: SchoolEvent[];
  leagueNews: LeagueNews[];

  isAggregatedTargetCompletionReportFormModalOpen: boolean;
  isAggregatedTargetCompletionForThePeriodReportFormModalOpen: boolean;
  isTargetParticipationStatisticsReportFormModalOpen: boolean;
  isTargetCompletionStatisticsReportFormModalOpen: boolean;

  forms: SchoolForm[];
  isColumnsOpen: boolean;
  isReportsModalOpen: boolean;
  visibleColumns: {
    aggregation: boolean;
    publicSite: boolean;
  };
}

export class SchoolLeagues extends Component<Props, State> {
  constructor(props) {
    super(props);

    const visibleColumns = this.loadVisibleColumns(props.user);

    this.state = {
      items: [],
      currentPage: FIRST_PAGE,
      selectedItems: [],
      viewedLeague: null,
      editingLeague: null,
      sortDirection: '',
      sortColumnsName: '',
      isShowFilter: false,
      isDataFiltered: false,
      filters: {},
      isLoading: false,
      isSelectAllChecked: false,
      total: 0,
      basePath: '',
      currentTabIndex: 0,
      leagueId: propz.get(this.props.location, ['state', 'leagueId']),
      isErrorModalOpen: false,
      errorMessage: '',
      isEditLeaguePopupOpened: false,
      isDeleteLeagueModalOpen: false,
      leaguePhotos: [],
      leagueEvents: [],
      leagueNews: [],
      isAggregatedTargetCompletionReportFormModalOpen: false,
      isAggregatedTargetCompletionForThePeriodReportFormModalOpen: false,
      isTargetParticipationStatisticsReportFormModalOpen: false,
      isTargetCompletionStatisticsReportFormModalOpen: false,
      forms: [],
      isColumnsOpen: false,
      isReportsModalOpen: false,
      visibleColumns
    };
  }

  componentDidMount() {
    document.addEventListener('keydown', this.onDocumentKeyDown);
    window.dispatchEvent(new CustomEvent('sit:topbar-breadcrumb', { detail: 'School leagues' }));
    this.setState({
      isLoading: true
    });

    this.setAdditionalItems().then(res => {
      this.setItems();
    });
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onDocumentKeyDown);
    window.dispatchEvent(new CustomEvent('sit:topbar-breadcrumb-clear'));
  }

  getColumnsStorageKey = (user: AppUser): string =>
    `columnVisibility__${propz.get(user, ['userId'], 'anonymous')}__school-leagues`;

  loadVisibleColumns = (user: AppUser): State['visibleColumns'] => {
    const defaults = { aggregation: true, publicSite: true };
    try {
      const saved = window.localStorage.getItem(this.getColumnsStorageKey(user));
      return saved ? { ...defaults, ...JSON.parse(saved) } : defaults;
    } catch (error) {
      return defaults;
    }
  };

  onDocumentKeyDown = (event: KeyboardEvent): void => {
    if (event.key === 'Escape') {
      if (this.state.isShowFilter) {
        this.onCancelFilterClick();
      } else {
        this.setState({ isColumnsOpen: false, isReportsModalOpen: false });
      }
    }
  };

  setAdditionalItems() {
    const { user } = this.props;

    return getAllForms(user).then(forms => {
      this.setState({
        forms
      });
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      this.setState({
        isLoading: true
      });

      this.setItems();
    }
  }

  getLeagueFilters = (search: any): any => {
    const filters = getFilters2(COLUMNS, search);
    const validAggregationTypes = getSelectOptionForAggregationType().map(option => String(option.value));
    const aggregationTypes = Array.isArray(filters.aggregationType)
      ? filters.aggregationType
      : filters.aggregationType
      ? [filters.aggregationType]
      : [];

    return {
      ...filters,
      aggregationType: aggregationTypes
        .map(value => String(value))
        .filter(value => validAggregationTypes.includes(value))
    };
  };

  setItems() {
    const { history, user } = this.props;
    const { leagueId } = this.state;

    const search = parse(history.location.search);
    const page = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;

    let sortDirection: TABLE_SORT_DIRECTION = '';
    let sortColumnsName = '';

    if (typeof search.order === 'string') {
      [sortColumnsName, sortDirection] = search.order.split(':');
    }

    const sortByFieldExist = sortColumnsName !== '';
    const sortDirectionExist = sortDirection !== '';

    const filters = this.getLeagueFilters(search);

    const isDataFiltered = isFilterExist2(filters);

    const where = getServerFieldSectionWhere(filters);

    const order = sortByFieldExist && sortDirectionExist ? `${sortColumnsName} ${sortDirection}` : undefined;
    const serverQueryFilter = getServerQueryFilter2(page, where, order);

    const getItemsPromise = getSchoolLeagues(user, serverQueryFilter);
    const getItemsCountPromise = getSchoolLeaguesCount(user, where);

    return BPromise.all([getItemsCountPromise, getItemsPromise]).then(([countObj, items]) => {
      if (typeof leagueId !== 'undefined') {
        const league = items.find(item => item.id === leagueId);
        this.setState({
          currentPage: page,
          sortDirection: sortDirection as TABLE_SORT_DIRECTION,
          sortColumnsName: sortColumnsName,
          isShowFilter: false,
          isDataFiltered: isDataFiltered,
          filters: filters,
          items: items,
          total: countObj.count,
          basePath: history.location.pathname,
          isLoading: false,
          selectedItems: [],
          viewedLeague: typeof league !== 'undefined' ? league : null,
          leagueId: undefined
        });
        //clear history
        const state = { ...(history.location.state as any) };
        delete state.leagueId;
        history.replace({ ...history.location, state });
      } else {
        this.setState({
          currentPage: page,
          sortDirection: sortDirection,
          sortColumnsName: sortColumnsName,
          isShowFilter: false,
          isDataFiltered: isDataFiltered,
          filters: filters,
          items: items,
          total: countObj.count,
          basePath: history.location.pathname,
          isLoading: false
        });
      }
      return true;
    });
  }

  setCurrentPageParams = (currentPage: number): void => {
    let search: string[] = [];

    const { filters, sortColumnsName, sortDirection } = this.state;

    if (currentPage !== 1) {
      search.push(`page=${currentPage}`);
    }

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onItemClick = (index: number): void => {
    const league = this.state.items[index];
    this.setState({ viewedLeague: league, currentTabIndex: 0, leagueEvents: [], leagueNews: [] }, () =>
      this.loadLeagueRelatedItems(league)
    );
  };

  onItemSelect = (index: number): void => {
    const { items, selectedItems } = this.state;
    const selectedItem = items[index];

    const selectedItemIndex = selectedItems.findIndex(item => selectedItem.id === item.id);
    let selectedItemsUpdated = [...selectedItems];

    if (selectedItemIndex !== -1) {
      selectedItemsUpdated.splice(selectedItemIndex, 1);
    } else {
      selectedItemsUpdated.push(selectedItem);
    }

    this.setState({ selectedItems: selectedItemsUpdated });
  };

  loadLeagueRelatedItems = (league: SchoolLeague): void => {
    const { user } = this.props;

    BPromise.all([getSchoolLeagueEvents(user, league.id), getAllSchoolLeagueNews(user, league.id)])
      .then(([leagueEvents, leagueNews]) => {
        const currentLeague = this.state.viewedLeague;
        if (currentLeague && currentLeague.id === league.id) {
          this.setState({ leagueEvents, leagueNews });
        }
      })
      .catch(error => {
        console.error(error);
      });
  };

  onSelectAllOnPageClick = (): void => {
    const { items, selectedItems } = this.state;

    const itemsFiltered = items.filter(item => {
      return selectedItems.every(selectedItem => selectedItem.id !== item.id);
    });

    const nextSelectedItems = [...selectedItems, ...itemsFiltered];

    this.setState({
      selectedItems: nextSelectedItems,
      isSelectAllChecked: true
    });
  };

  onSelectAllClick = (): void => {
    const { selectedItems, filters } = this.state;

    this.setState({
      isLoading: true
    });

    const user = this.props.user;

    const where = getServerFieldSectionWhere(filters);

    getAllSchoolLeagues(user, where).then(items => {
      const itemsFiltered = items.filter(item => {
        return selectedItems.every(selectedItem => selectedItem.id !== item.id);
      });

      const nextSelectedItems = [...selectedItems, ...itemsFiltered];

      this.setState({
        selectedItems: nextSelectedItems,
        isSelectAllChecked: true,
        isLoading: false
      });
    });
  };

  onUnselectAllClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false
    });
  };

  closeLeagueDetails = (): void => {
    this.setState({ viewedLeague: null, currentTabIndex: 0, leagueEvents: [], leagueNews: [] });
  };

  onTableSortClick = (sortField: string): void => {
    const { sortDirection, sortColumnsName, filters } = this.state;

    const order = getOrder(sortField, sortDirection, sortColumnsName);

    let search: string[] = [];
    search.push(`order=${sortField}:${order}`);

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onTableFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.filters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (filterField === 'ageGroup') {
      nextFilters.ageGroup = [];
    }

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue
            }
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue
            }
          };
          break;
      }
    } else {
      const filter = COLUMNS.find(col => col.field === filterField);
      const filterType = filter.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue
        };
      }
    }

    this.setState({
      filters: nextFilters
    });
  };

  onApplyFilterClick = (): void => {
    const { filters, sortDirection, sortColumnsName } = this.state;
    let search: string[] = [];

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
      isShowFilter: false
    });

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onClearFilterClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
      isShowFilter: false,
      filters: this.getLeagueFilters({})
    });

    this.props.history.push({
      pathname: this.state.basePath,
      search: ''
    });
  };

  onTableFilterClick = (event): void => {
    event.preventDefault();

    const isShowFilter = this.state.isShowFilter;

    this.setState({
      isShowFilter: !isShowFilter,
      isColumnsOpen: false
    });
  };

  onCancelFilterClick = (): void => {
    const search = parse(this.props.history.location.search);
    this.setState({
      filters: this.getLeagueFilters(search),
      isShowFilter: false
    });
  };

  clearFilterField = (field: string): void => {
    this.setState(
      state => ({
        filters: {
          ...state.filters,
          [field]: field === 'aggregationType' ? [] : ''
        }
      }),
      this.onApplyFilterClick
    );
  };

  toggleAggregationFilter = (value: string, applyImmediately = false): void => {
    const updateFilters = (state: State) => {
      const currentValues = Array.isArray(state.filters.aggregationType)
        ? state.filters.aggregationType
        : state.filters.aggregationType
        ? [state.filters.aggregationType]
        : [];
      const nextValues = currentValues.includes(value)
        ? currentValues.filter(item => item !== value)
        : [...currentValues, value];

      return {
        filters: {
          ...state.filters,
          aggregationType: nextValues
        }
      } as Pick<State, 'filters'>;
    };

    if (applyImmediately) {
      this.setState(updateFilters, this.onApplyFilterClick);
    } else {
      this.setState(updateFilters);
    }
  };

  toggleColumn = (column: 'aggregation' | 'publicSite'): void => {
    this.setState(
      state => ({
        visibleColumns: {
          ...state.visibleColumns,
          [column]: !state.visibleColumns[column]
        }
      }),
      () => {
        try {
          window.localStorage.setItem(
            this.getColumnsStorageKey(this.props.user),
            JSON.stringify(this.state.visibleColumns)
          );
        } catch (error) {
          // Storage can be unavailable in privacy mode; the list remains usable.
        }
      }
    );
  };

  getPublicSiteDisplay = (league: SchoolLeague): { label: string; className: string } => {
    const status = String(propz.get(league, ['publicSite', 'status'], '') || '').toLowerCase();

    if (['public_available', 'enabled', 'active', 'published', 'live'].indexOf(status) !== -1) {
      return { label: 'Public', className: 'is-published' };
    }
    if (status === 'protected') {
      return { label: 'Password protected', className: 'is-protected' };
    }
    return { label: 'Not published', className: 'is-disabled' };
  };

  onSaveButtonClick = (data): void => {
    const { user } = this.props;
    const { editingLeague } = this.state;

    this.setState({
      isLoading: true
    });

    const isNotIndividualLeague = data.aggregationType !== LEAGUE_AGGREGATION_TYPE.INDIVIDUAL;
    if (isNotIndividualLeague) {
      data.isDisplayHousePoints = false;
    }

    if (!editingLeague) {
      createSchoolLeagues(user, data)
        .then(league => {
          this.setState({
            isEditLeaguePopupOpened: false,
            selectedItems: [],
            editingLeague: null
          });
          this.setItems();
        })
        .catch(error => {
          const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
          console.error(error);
          this.setState({
            isLoading: false,
            errorMessage: errorText,
            isErrorModalOpen: true
          });
        });
    } else {
      const leagueId = editingLeague.id;
      updateSchoolLeagues(user, leagueId, data)
        .then(league => {
          this.setState({
            isEditLeaguePopupOpened: false,
            editingLeague: null,
            viewedLeague:
              this.state.viewedLeague && this.state.viewedLeague.id === league.id ? league : this.state.viewedLeague
          });
          this.setItems();
        })
        .catch(error => {
          const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
          console.error(error);
          this.setState({
            isLoading: false,
            errorMessage: errorText,
            isErrorModalOpen: true
          });
        });
    }
  };

  onCancelButtonClick = (): void => {
    this.setState({
      isEditLeaguePopupOpened: false,
      editingLeague: null
    });
  };

  onTabClick = (event, index: number) => {
    event.preventDefault();
    const { user } = this.props;
    const league = this.state.viewedLeague || this.state.selectedItems[0];
    const tabs = LEAGUE_TABS;
    const currentTab = tabs[index];

    switch (currentTab) {
      case TABS.EVENTS:
        this.setState({ currentTabIndex: index });
        getSchoolLeagueEvents(user, league.id)
          .then(events => {
            this.setState({ leagueEvents: events });
          })
          .catch(error => console.error(error));
        break;
      case TABS.NEWS:
        this.setState({ currentTabIndex: index });
        getAllSchoolLeagueNews(user, league.id)
          .then(news => {
            this.setState({ leagueNews: news });
          })
          .catch(error => console.error(error));
        break;
      default:
        this.setState({
          currentTabIndex: index
        });
    }
  };

  onEditLeagueClick = event => {
    event.preventDefault();

    this.setState({
      isEditLeaguePopupOpened: true,
      editingLeague:
        this.state.viewedLeague || (this.state.selectedItems.length === 1 ? this.state.selectedItems[0] : null)
    });
  };

  onCreateEventClick = aggregationType => {
    const { history } = this.props;
    const currentSelectedItem = this.state.viewedLeague || this.state.selectedItems[0];
    const { id: leagueId } = currentSelectedItem;

    history.push({
      pathname: '/events/manager',
      state: { aggregationType, leagueId }
    });
  };

  onEditLeagueEventsClick = event => {
    event.preventDefault();
    const { basePath } = this.state;
    const leagueId = (this.state.viewedLeague || this.state.selectedItems[0]).id;

    this.props.history.push({
      pathname: `${basePath}/events`,
      search: `league=${leagueId}`
    });
  };

  onEditLeagueNewsClick = event => {
    event.preventDefault();
    const { basePath } = this.state;
    const { history } = this.props;
    const leagueId = (this.state.viewedLeague || this.state.selectedItems[0]).id;

    history.push({
      pathname: `${basePath}/news`,
      search: `league=${leagueId}`
    });
  };

  getSummaryTabs(): React.ReactNode {
    const { viewedLeague, currentTabIndex, leagueEvents, leagueNews } = this.state;
    const { user } = this.props;
    if (!viewedLeague) return null;

    const currentTab = LEAGUE_TABS[currentTabIndex];

    switch (currentTab) {
      case TABS.SUMMARY:
        return <SchoolLeagueSummary league={viewedLeague} />;
      case TABS.EVENTS:
        return <SchoolLeagueEventsSummary leagueEvents={leagueEvents} user={user} />;
      case TABS.NEWS:
        return <SchoolLeagueNewsSummary news={leagueNews} />;
    }
  }

  renderEditLeagueModal() {
    const { isEditLeaguePopupOpened, editingLeague } = this.state;
    const { user } = this.props;

    return (
      <SimpleModal
        isOpen={isEditLeaguePopupOpened}
        title={editingLeague ? 'Edit league' : 'Create league'}
        onCloseClick={this.onCancelButtonClick}
        showFooter={false}
        customClass="leagueFormModal"
      >
        <SchoolLeagueForm
          league={editingLeague || undefined}
          onSubmit={this.onSaveButtonClick}
          onCancel={this.onCancelButtonClick}
          user={user}
        />
      </SimpleModal>
    );
  }

  onCreateSchoolLeagueClick = () => {
    this.setState({
      isEditLeaguePopupOpened: true,
      editingLeague: null
    });
  };

  removeSchoolLeagueModalOpen = (): void => {
    this.setState({
      isDeleteLeagueModalOpen: true
    });
  };

  removeSchoolLeagueModalClose = (): void => {
    this.setState({
      isDeleteLeagueModalOpen: false
    });
  };

  onRemoveSchoolLeagueClick = () => {
    const { selectedItems } = this.state;
    const { user } = this.props;
    if (typeof selectedItems === 'undefined' || selectedItems.length === 0) {
      return;
    }
    this.setState({ isLoading: true });
    const promises = selectedItems.map(league => {
      return deleteSchoolLeagues(user, league.id);
    });
    BPromise.all(promises).then(() => {
      this.setState({
        selectedItems: [],
        isDeleteLeagueModalOpen: false
      });
      this.setItems();
    });
  };

  onAddEventsButtonClick = (): void => {
    const { selectedItems, viewedLeague } = this.state;
    const { history, location } = this.props;
    const { search: locationSearch } = location;
    const league = viewedLeague || selectedItems[0];
    if (!league) {
      return;
    }
    const leagueId = league.id;

    let search = [`league=${leagueId}`];

    if (isLeagueIndividual(league) || isLeagueTeam(league)) {
      search.push(`eventType=${EVENT_TYPES.INTERNAL_TEAMS}`);
    }

    if (isLeagueHouse(league)) {
      search.push(`eventType=${EVENT_TYPES.INTERNAL_HOUSES}`);
    }

    history.push({
      pathname: `/leagues/eligibleEvents`,
      search: search.join('&'),
      state: { search: locationSearch }
    });
  };

  renderDeleteSchoolLeagueModal() {
    const { selectedItems, isDeleteLeagueModalOpen } = this.state;

    return (
      <SimpleModal
        isOpen={isDeleteLeagueModalOpen}
        title={'Remove league'}
        body={`Are you sure you want to remove ${
          selectedItems.length === 1 ? `league ${selectedItems[0].name}` : `${selectedItems.length} leagues`
        }?`}
        buttonText={'Delete'}
        onButtonClick={this.onRemoveSchoolLeagueClick}
        onCloseClick={this.removeSchoolLeagueModalClose}
      />
    );
  }

  onSubmitReportForm = (data, reportType) => {
    const { user } = this.props;
    const { activeSchoolId, activeSchool } = user;
    const { selectedItems, forms } = this.state;
    const { ageGroupsNaming } = activeSchool;
    const ageGroup = propz.get(AGE_GROUPS_SORTED, [ageGroupsNaming]);

    const {
      dateTo,
      dateFrom,
      isShowCompleted,
      isShowUncompleted,
      isShowBlank,
      genders,
      ages: ageItems,
      isPrintEligible,
      isPrintParticipating,
      isPrintPercent,
      isPrintPP,
      isPrintSEN,
      isPrintFSM
    } = data;

    let modData;
    let formsUniq;
    let ages: number[];

    switch (reportType) {
      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.AGGREGATED_TARGET_COMPLETION:
        this.setState({
          isAggregatedTargetCompletionReportFormModalOpen: false,
          isLoading: true
        });

        formsUniq = Lazy(forms)
          .uniq('age')
          .sort((form1, form2) => {
            const ageIndex1 = ageGroup.indexOf(form1.ageGroup);
            const ageIndex2 = ageGroup.indexOf(form2.ageGroup);

            return ageIndex1 - ageIndex2;
          })
          .toArray();

        ages = formsUniq.filter((form, index) => ageItems[index].isChecked).map(form => form.age);

        modData = {
          reportParamsCSV: {
            schoolId: activeSchoolId,
            leagueId: selectedItems.map(item => item.id),
            showCompleted: isShowCompleted,
            showUncompleted: isShowUncompleted,
            showBlank: isShowBlank,
            genders: genders.filter(gender => gender.isChecked === true).map(gender => gender.name.toUpperCase()),
            ageGroups: ages
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.AGGREGATED_TARGET_COMPLETION_FOR_THE_PERIOD:
        this.setState({
          isAggregatedTargetCompletionForThePeriodReportFormModalOpen: false,
          isLoading: true
        });

        dateFrom.setHours(0, 0, 0, 0);
        dateTo.setHours(23, 59, 59, 0);

        formsUniq = Lazy(forms)
          .uniq('age')
          .sort((form1, form2) => {
            const ageIndex1 = ageGroup.indexOf(form1.ageGroup);
            const ageIndex2 = ageGroup.indexOf(form2.ageGroup);

            return ageIndex1 - ageIndex2;
          })
          .toArray();

        ages = formsUniq.filter((form, index) => ageItems[index].isChecked).map(form => form.age);

        modData = {
          reportParamsCSV: {
            schoolId: activeSchoolId,
            dateTo: moment(dateTo).format('YYYY-MM-DD HH:mm:ss'),
            dateFrom: moment(dateFrom).format('YYYY-MM-DD HH:mm:ss'),
            showCompleted: isShowCompleted,
            showUncompleted: isShowUncompleted,
            showBlank: isShowBlank,
            genders: genders.filter(gender => gender.isChecked === true).map(gender => gender.name.toUpperCase()),
            ageGroups: ages
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.TARGET_PARTICIPATION_STATISTICS:
        this.setState({
          isTargetParticipationStatisticsReportFormModalOpen: false,
          isLoading: true
        });

        modData = {
          reportParamsCSV: {
            schoolId: activeSchoolId,
            leagueId: selectedItems.map(item => item.id),
            printEligible: isPrintEligible,
            printPercent: isPrintPercent,
            printPP: isPrintPP,
            printSEN: isPrintSEN,
            printFSM: isPrintFSM
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.TARGET_COMPLETION_STATISTICS:
        this.setState({
          isTargetCompletionStatisticsReportFormModalOpen: false,
          isLoading: true
        });

        modData = {
          reportParamsCSV: {
            schoolId: activeSchoolId,
            leagueId: selectedItems.map(item => item.id),
            printParticipating: isPrintParticipating,
            printPercent: isPrintPercent,
            printPP: isPrintPP,
            printSEN: isPrintSEN,
            printFSM: isPrintFSM
          }
        };
        break;
    }

    uploadReport(user, reportType, modData)
      .then(data => {
        if (typeof data.reportId !== 'undefined') {
          const reportType = data.reportType;
          this.setState({
            isLoading: false
          });
          const url = `${window.apiBase}/public/report/${data.reportId}/reportType/${reportType}`;
          window.open(url);
        } else {
          this.setState({
            isLoading: false,
            errorMessage: 'No read report',
            isErrorModalOpen: true
          });
        }
      })
      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
        console.error(error);

        this.setState({
          isLoading: false,
          errorMessage: errorText,
          isErrorModalOpen: true
        });
      });
  };

  renderSendingError(): React.ReactNode {
    const { errorMessage, isErrorModalOpen } = this.state;

    return (
      <SimpleModal
        isOpen={isErrorModalOpen}
        title={'Error'}
        body={errorMessage}
        buttonCancelText={'Ok'}
        onCloseClick={this.onCloseErrorClick}
      />
    );
  }

  onCloseErrorClick = () => {
    this.setState({
      isErrorModalOpen: false,
      errorMessage: ''
    });
  };

  renderReportModalTitle = (title: string, category: string = 'League report') => (
    <div className="leagueReportModalTitle">
      <span className="leagueReportModalTitle__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M8 13h8M8 17h5" />
        </svg>
      </span>
      <span className="leagueReportModalTitle__copy">
        <span className="leagueReportModalTitle__name">{title}</span>
        <span className="leagueReportModalTitle__category">{category}</span>
      </span>
    </div>
  );

  renderAggregatedTargetCompletionReportFormModal() {
    const { isAggregatedTargetCompletionReportFormModalOpen, forms } = this.state;
    const { user } = this.props;
    const { activeSchool } = user;
    return (
      <SimpleModal
        isOpen={isAggregatedTargetCompletionReportFormModalOpen}
        title={this.renderReportModalTitle('Target completion', 'League report')}
        onCloseClick={this.closeAggregatedTargetCompletionReportForm}
        showFooter={false}
        customClass="leagueReportParametersModal"
        bodyClassName="leagueReportParametersModal__body"
        isBodyBold={false}
      >
        <AggregatedTargetCompletionReportForm
          onCloseClick={this.closeAggregatedTargetCompletionReportForm}
          onSubmit={this.onSubmitReportForm}
          forms={forms}
          school={activeSchool}
        />
      </SimpleModal>
    );
  }

  renderAggregatedTargetCompletionForThePeriodReportFormModal() {
    const { isAggregatedTargetCompletionForThePeriodReportFormModalOpen, forms } = this.state;
    const { user } = this.props;
    const { activeSchool } = user;
    return (
      <SimpleModal
        isOpen={isAggregatedTargetCompletionForThePeriodReportFormModalOpen}
        title={this.renderReportModalTitle('Completion for period', 'League report')}
        onCloseClick={this.closeAggregatedTargetCompletionForThePeriodReportForm}
        showFooter={false}
        customClass="leagueReportParametersModal"
        bodyClassName="leagueReportParametersModal__body"
        isBodyBold={false}
      >
        <AggregatedTargetCompletionForThePeriodReportForm
          onCloseClick={this.closeAggregatedTargetCompletionForThePeriodReportForm}
          onSubmit={this.onSubmitReportForm}
          forms={forms}
          school={activeSchool}
        />
      </SimpleModal>
    );
  }

  renderTargetParticipationStatisticsReportFormModal() {
    const { isTargetParticipationStatisticsReportFormModalOpen, forms } = this.state;
    const { user } = this.props;
    const { activeSchool } = user;
    return (
      <SimpleModal
        isOpen={isTargetParticipationStatisticsReportFormModalOpen}
        title={this.renderReportModalTitle('Participation statistics', 'League report')}
        onCloseClick={this.closeTargetParticipationStatisticsReportForm}
        showFooter={false}
        customClass="leagueReportParametersModal"
        bodyClassName="leagueReportParametersModal__body"
        isBodyBold={false}
      >
        <TargetParticipationStatisticsReportForm
          onCloseClick={this.closeTargetParticipationStatisticsReportForm}
          onSubmit={this.onSubmitReportForm}
          forms={forms}
          school={activeSchool}
        />
      </SimpleModal>
    );
  }

  renderTargetCompletionStatisticsReportFormModal() {
    const { isTargetCompletionStatisticsReportFormModalOpen, forms } = this.state;
    const { user } = this.props;
    const { activeSchool } = user;
    return (
      <SimpleModal
        isOpen={isTargetCompletionStatisticsReportFormModalOpen}
        title={this.renderReportModalTitle('Completion statistics', 'League report')}
        onCloseClick={this.closeTargetCompletionStatisticsReportForm}
        showFooter={false}
        customClass="leagueReportParametersModal"
        bodyClassName="leagueReportParametersModal__body"
        isBodyBold={false}
      >
        <TargetCompletionStatisticsReportForm
          onCloseClick={this.closeTargetCompletionStatisticsReportForm}
          onSubmit={this.onSubmitReportForm}
          forms={forms}
          school={activeSchool}
        />
      </SimpleModal>
    );
  }

  renderSummary() {
    const { viewedLeague: currentSelectedItem, currentTabIndex } = this.state;
    if (!currentSelectedItem) return null;
    const { aggregationType } = currentSelectedItem;

    const summaryTabs = this.getSummaryTabs();
    const currentTab = LEAGUE_TABS[currentTabIndex];

    const isShowEditButton = currentTab === TABS.SUMMARY;
    const isShowEditEventsButton = currentTab === TABS.EVENTS;
    const isShowEditNewsButton = currentTab === TABS.NEWS;

    return (
      <>
        <button className="leaguesDrawer__scrim" onClick={this.closeLeagueDetails} aria-label="Close league details" />
        <aside className="leaguesDrawer">
          <header>
            <i>
              <LeagueIcon />
            </i>
            <div>
              <h2>{currentSelectedItem.name}</h2>
              <p>{LEAGUE_AGGREGATION_TYPE_SERVER_TO_CLIENT_MAPPING[aggregationType] || aggregationType} league</p>
            </div>
            <button onClick={this.closeLeagueDetails}>×</button>
          </header>
          <nav>
            {LEAGUE_TABS.map((tab, index) => (
              <button
                key={tab}
                className={currentTabIndex === index ? 'is-active' : ''}
                onClick={event => this.onTabClick(event, index)}
              >
                {tab}
                {index === 1 && <span>{this.state.leagueEvents.length}</span>}
                {index === 2 && <span>{this.state.leagueNews.length}</span>}
              </button>
            ))}
          </nav>
          <main>{summaryTabs}</main>
          <footer>
            {isShowEditButton && (
              <>
                <button className="leagueButton" onClick={() => this.onCreateEventClick(aggregationType)}>
                  Create event
                </button>
                <button className="leagueButton leagueButton--primary" onClick={this.onEditLeagueClick}>
                  Edit details
                </button>
              </>
            )}
            {isShowEditEventsButton && (
              <>
                <button className="leagueButton" onClick={this.onAddEventsButtonClick}>
                  Add events
                </button>
                <button className="leagueButton leagueButton--primary" onClick={this.onEditLeagueEventsClick}>
                  Manage events
                </button>
              </>
            )}
            {isShowEditNewsButton && (
              <button className="leagueButton leagueButton--primary" onClick={this.onEditLeagueNewsClick}>
                Manage news
              </button>
            )}
          </footer>
        </aside>
      </>
    );
  }

  openAggregatedTargetCompletionReportForm = () => {
    this.setState({
      isAggregatedTargetCompletionReportFormModalOpen: true
    });
  };

  closeAggregatedTargetCompletionReportForm = () => {
    this.setState({
      isAggregatedTargetCompletionReportFormModalOpen: false
    });
  };

  openAggregatedTargetCompletionForThePeriodReportForm = () => {
    this.setState({
      isAggregatedTargetCompletionForThePeriodReportFormModalOpen: true
    });
  };

  closeAggregatedTargetCompletionForThePeriodReportForm = () => {
    this.setState({
      isAggregatedTargetCompletionForThePeriodReportFormModalOpen: false
    });
  };

  openTargetParticipationStatisticsReportForm = () => {
    this.setState({
      isTargetParticipationStatisticsReportFormModalOpen: true
    });
  };

  closeTargetParticipationStatisticsReportForm = () => {
    this.setState({
      isTargetParticipationStatisticsReportFormModalOpen: false
    });
  };

  openTargetCompletionStatisticsReportForm = () => {
    this.setState({
      isTargetCompletionStatisticsReportFormModalOpen: true
    });
  };

  closeTargetCompletionStatisticsReportForm = () => {
    this.setState({
      isTargetCompletionStatisticsReportFormModalOpen: false
    });
  };

  renderReportsModal(): React.ReactNode {
    const { isReportsModalOpen, selectedItems } = this.state;
    if (!isReportsModalOpen) {
      return null;
    }

    const reports = [
      {
        title: 'Target completion',
        description: 'Review completed, incomplete and unassigned targets for the selected leagues.',
        action: this.openAggregatedTargetCompletionReportForm,
        needsSelection: true
      },
      {
        title: 'Completion for period',
        description: 'Summarise target completion within a chosen date range.',
        action: this.openAggregatedTargetCompletionForThePeriodReportForm,
        needsSelection: false
      },
      {
        title: 'Participation statistics',
        description: 'Create participation statistics for the selected leagues.',
        action: this.openTargetParticipationStatisticsReportForm,
        needsSelection: true
      },
      {
        title: 'Completion statistics',
        description: 'Create completion statistics for the selected leagues.',
        action: this.openTargetCompletionStatisticsReportForm,
        needsSelection: true
      }
    ].filter(report => !report.needsSelection || selectedItems.length > 0);

    return (
      <SimpleModal
        isOpen={true}
        title="Printed forms & reports"
        onCloseClick={() => this.setState({ isReportsModalOpen: false })}
        showFooter={false}
        customClass="leagueReportsModal"
        isBodyBold={false}
      >
        <div className="eEventPrintModal__intro">
          Choose a report. You can configure its contents and format on the next step.
        </div>
        <section className="eEventPrintModal__group">
          <h3 className="eEventPrintModal__groupTitle">League reports</h3>
          <div className="eEventPrintModal__list">
            {reports.map(report => {
              return (
                <button
                  type="button"
                  className="eEventPrintModal__item"
                  key={report.title}
                  onClick={() => this.setState({ isReportsModalOpen: false }, report.action)}
                >
                  <span className="eEventPrintModal__itemIcon" aria-hidden="true">
                    <svg viewBox="0 0 24 24">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M8 13h8M8 17h5" />
                    </svg>
                  </span>
                  <span className="eEventPrintModal__itemCopy">
                    <span className="eEventPrintModal__itemHeading">
                      <span>{report.title}</span>
                      <span className="eEventPrintModal__format">Excel</span>
                    </span>
                    <span className="eEventPrintModal__itemDescription">{report.description}</span>
                  </span>
                  <span className="eEventPrintModal__arrow" aria-hidden="true">
                    ›
                  </span>
                </button>
              );
            })}
          </div>
        </section>
      </SimpleModal>
    );
  }

  render() {
    const {
      items,
      sortDirection,
      sortColumnsName,
      isShowFilter,
      isDataFiltered,
      selectedItems,
      filters,
      isLoading,
      isSelectAllChecked,
      currentPage,
      total,
      isEditLeaguePopupOpened,
      isDeleteLeagueModalOpen,
      isAggregatedTargetCompletionReportFormModalOpen,
      isAggregatedTargetCompletionForThePeriodReportFormModalOpen,
      isTargetParticipationStatisticsReportFormModalOpen,
      isTargetCompletionStatisticsReportFormModalOpen,
      isErrorModalOpen,
      isColumnsOpen,
      visibleColumns,
      isReportsModalOpen
    } = this.state;

    if (isLoading) {
      return <Loader />;
    }

    const classes =
      isErrorModalOpen ||
      isEditLeaguePopupOpened ||
      isDeleteLeagueModalOpen ||
      isAggregatedTargetCompletionReportFormModalOpen ||
      isAggregatedTargetCompletionForThePeriodReportFormModalOpen ||
      isTargetParticipationStatisticsReportFormModalOpen ||
      isTargetCompletionStatisticsReportFormModalOpen ||
      isReportsModalOpen
        ? 'schoolLeaguesRoute modal-open'
        : 'schoolLeaguesRoute';

    const selectedIds = new Set(selectedItems.map(item => item.id));
    const pageCount = Math.max(1, Math.ceil(total / LIMIT));
    const firstResult = total === 0 ? 0 : (currentPage - 1) * LIMIT + 1;
    const lastResult = Math.min(currentPage * LIMIT, total);
    const pageNumbers: number[] = [];
    const pageStart = Math.max(1, Math.min(currentPage - 1, pageCount - 2));
    const pageEnd = Math.min(pageCount, pageStart + 2);
    for (let pageNumber = pageStart; pageNumber <= pageEnd; pageNumber++) {
      pageNumbers.push(pageNumber);
    }
    const nameFilter = filters.name || '';
    const aggregationValue = filters.aggregationType || '';
    const aggregationFilters = Array.isArray(aggregationValue)
      ? aggregationValue
      : aggregationValue
      ? [aggregationValue]
      : [];
    const aggregationOptions = getSelectOptionForAggregationType();

    return (
      <div className={classes}>
        {/*Place for render modal windows*/}
        {this.renderDeleteSchoolLeagueModal()}
        {this.renderEditLeagueModal()}
        {this.renderSendingError()}
        {this.renderAggregatedTargetCompletionReportFormModal()}
        {this.renderAggregatedTargetCompletionForThePeriodReportFormModal()}
        {this.renderTargetParticipationStatisticsReportFormModal()}
        {this.renderTargetCompletionStatisticsReportFormModal()}
        {this.renderReportsModal()}
        <div className="schoolLeaguesPage">
          <header className="schoolLeaguesPage__header">
            <div>
              <h1>School leagues</h1>
              <p>
                {total} {total === 1 ? 'league' : 'leagues'}
              </p>
            </div>
            <div className="schoolLeaguesPage__toolbar">
              <label className="schoolLeaguesPage__search">
                <span>League</span>
                <input
                  value={nameFilter}
                  placeholder="Search leagues…"
                  onChange={event => this.onTableFilterChange(event, 'name')}
                  onKeyDown={event => event.key === 'Enter' && this.onApplyFilterClick()}
                />
              </label>
              <div className="schoolLeaguesPage__filterControl">
                {isShowFilter && (
                  <button
                    type="button"
                    className="schoolLeaguesPage__popoverScrim"
                    aria-label="Dismiss filters"
                    onClick={this.onCancelFilterClick}
                  />
                )}
                <button
                  className={`leagueButton ${isShowFilter ? 'is-active' : ''}`}
                  onClick={this.onTableFilterClick}
                  aria-expanded={isShowFilter}
                >
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M4 6h16M7 12h10M10 18h4" />
                  </svg>
                  Filters
                  {isDataFiltered && <span className="schoolLeaguesPage__filterDot" />}
                </button>
                {isShowFilter && (
                  <div
                    className="schoolLeaguesPage__filterPopover"
                    onKeyDown={event => {
                      const target = event.target as HTMLElement;
                      if (event.key === 'Enter' && (target.tagName === 'INPUT' || target.tagName === 'SELECT')) {
                        event.preventDefault();
                        this.onApplyFilterClick();
                      }
                    }}
                  >
                    <header>
                      <strong>Filters</strong>
                      <button type="button" onClick={this.onCancelFilterClick} aria-label="Close filters">
                        ×
                      </button>
                    </header>
                    <div className="schoolLeaguesPage__filterFields">
                      <fieldset className="schoolLeaguesPage__filterChips">
                        <legend>League type</legend>
                        <div>
                          {aggregationOptions.map((option, index) => (
                            <button
                              key={option.value}
                              type="button"
                              className={aggregationFilters.includes(String(option.value)) ? 'is-selected' : ''}
                              aria-pressed={aggregationFilters.includes(String(option.value))}
                              autoFocus={index === 0}
                              onClick={() => this.toggleAggregationFilter(String(option.value))}
                            >
                              {option.text}
                            </button>
                          ))}
                        </div>
                      </fieldset>
                    </div>
                    <footer>
                      <button type="button" className="is-clear" onClick={this.onClearFilterClick}>
                        Clear all
                      </button>
                      <div>
                        <button type="button" onClick={this.onCancelFilterClick}>
                          Cancel
                        </button>
                        <button type="button" className="is-apply" onClick={this.onApplyFilterClick}>
                          Apply
                        </button>
                      </div>
                    </footer>
                  </div>
                )}
              </div>
              <div className="schoolLeaguesPage__columns">
                {isColumnsOpen && (
                  <button
                    type="button"
                    className="schoolLeaguesPage__popoverScrim"
                    aria-label="Close column settings"
                    onClick={() => this.setState({ isColumnsOpen: false })}
                  />
                )}
                <button
                  className="leagueButton"
                  onClick={() => this.setState({ isColumnsOpen: !isColumnsOpen, isShowFilter: false })}
                  aria-expanded={isColumnsOpen}
                >
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <rect x="4" y="5" width="16" height="14" rx="2" />
                    <path d="M10 5v14M15 5v14" />
                  </svg>
                  Columns
                </button>
                {isColumnsOpen && (
                  <div className="schoolLeaguesPage__columnsMenu">
                    <header>Show columns</header>
                    <label>
                      <input type="checkbox" checked={true} disabled={true} />
                      <span>League</span>
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        checked={visibleColumns.aggregation}
                        onChange={() => this.toggleColumn('aggregation')}
                      />
                      <span>Type</span>
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        checked={visibleColumns.publicSite}
                        onChange={() => this.toggleColumn('publicSite')}
                      />
                      <span>Public site</span>
                    </label>
                  </div>
                )}
              </div>
              <button
                type="button"
                className="leagueButton"
                onClick={() => this.setState({ isReportsModalOpen: true, isShowFilter: false, isColumnsOpen: false })}
              >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M6 3h9l3 3v15H6zM15 3v4h4M9 12h6M9 16h6" />
                </svg>
                Reports
              </button>
              <button className="leagueButton leagueButton--primary" onClick={this.onCreateSchoolLeagueClick}>
                <span aria-hidden="true">＋</span> Create league
              </button>
            </div>
          </header>
          {isDataFiltered && (
            <div className="schoolLeaguesPage__chips">
              {nameFilter && (
                <button type="button" onClick={() => this.clearFilterField('name')}>
                  Name: {nameFilter} <span>×</span>
                </button>
              )}
              {aggregationFilters.map(aggregationFilter => (
                <button
                  key={aggregationFilter}
                  type="button"
                  onClick={() => this.toggleAggregationFilter(aggregationFilter, true)}
                >
                  Type: {LEAGUE_AGGREGATION_TYPE_SERVER_TO_CLIENT_MAPPING[aggregationFilter] || aggregationFilter}{' '}
                  <span>×</span>
                </button>
              ))}
              <button type="button" className="is-clear" onClick={this.onClearFilterClick}>
                Clear all
              </button>
            </div>
          )}
          {selectedItems.length > 0 && (
            <div className="schoolLeaguesPage__selection">
              <span>{selectedItems.length} selected</span>
              <div>
                {selectedItems.length === 1 && (
                  <>
                    <button onClick={this.onEditLeagueClick}>Edit</button>
                    <button onClick={this.onAddEventsButtonClick}>Add events</button>
                  </>
                )}
                <button className="is-danger" onClick={this.removeSchoolLeagueModalOpen}>
                  Delete
                </button>
                <button onClick={this.onUnselectAllClick}>Clear</button>
              </div>
            </div>
          )}
          <section className="schoolLeaguesPage__card">
            <table>
              <thead>
                <tr>
                  <th>
                    <SelectAllCheckbox
                      compact
                      isChecked={isSelectAllChecked || (items.length > 0 && items.every(item => selectedIds.has(item.id)))}
                      totalCount={total}
                      currentPage={currentPage}
                      pageItemsCount={items.length}
                      selectedItems={selectedItems}
                      onSelectAllOnPageClick={this.onSelectAllOnPageClick}
                      onSelectAllClick={this.onSelectAllClick}
                      onUnselectAllClick={this.onUnselectAllClick}
                    />
                  </th>
                  <th>
                    <button onClick={() => this.onTableSortClick('name')}>League</button>
                  </th>
                  {visibleColumns.aggregation && <th>Type</th>}
                  {visibleColumns.publicSite && <th>Public site</th>}
                  <th />
                </tr>
              </thead>
              <tbody>
                {items.map((league, index) => (
                  <tr
                    key={league.id}
                    className={selectedIds.has(league.id) ? 'is-selected' : ''}
                    onClick={() => this.onItemClick(index)}
                  >
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedIds.has(league.id)}
                        onChange={() => this.onItemSelect(index)}
                        onClick={event => event.stopPropagation()}
                      />
                    </td>
                    <td>
                      <div className="schoolLeaguesPage__name">
                        <i>
                          <LeagueIcon />
                        </i>
                        <div>
                          <strong>{league.name}</strong>
                          <small>{league.description || 'School league'}</small>
                        </div>
                      </div>
                    </td>
                    {visibleColumns.aggregation && (
                      <td>
                        <span className={`schoolLeaguesPage__type is-${league.aggregationType.toLowerCase()}`}>
                          {LEAGUE_AGGREGATION_TYPE_SERVER_TO_CLIENT_MAPPING[league.aggregationType] ||
                            league.aggregationType}
                        </span>
                      </td>
                    )}
                    {visibleColumns.publicSite && (
                      <td>
                        <span className={`schoolLeaguesPage__site ${this.getPublicSiteDisplay(league).className}`}>
                          {this.getPublicSiteDisplay(league).label}
                        </span>
                      </td>
                    )}
                    <td>
                      <button className="schoolLeaguesPage__more" aria-label={`Open ${league.name}`}>
                        ›
                      </button>
                    </td>
                  </tr>
                ))}
                {!items.length && (
                  <tr>
                    <td
                      colSpan={3 + Number(visibleColumns.aggregation) + Number(visibleColumns.publicSite)}
                      className="schoolLeaguesPage__empty"
                    >
                      <ListEmptyState
                        icon={faTrophy}
                        title={isDataFiltered ? 'No school leagues match your filters' : 'No school leagues yet'}
                        description={
                          isDataFiltered
                            ? 'Try changing or clearing the filters to see other school leagues.'
                            : 'Create a league to organise fixtures, tables and results for your school.'
                        }
                      />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </section>
          {total > 0 && (
            <nav className="schoolLeaguesPage__pagination">
              <span className="schoolLeaguesPage__paginationInfo">
                Showing {firstResult}–{lastResult} of {total}
              </span>
              <div>
                <button
                  className="is-arrow"
                  disabled={currentPage <= 1}
                  onClick={() => this.setCurrentPageParams(currentPage - 1)}
                  aria-label="Previous page"
                >
                  ‹
                </button>
                {pageStart > 1 && (
                  <>
                    <button onClick={() => this.setCurrentPageParams(1)}>1</button>
                    {pageStart > 2 && <span>…</span>}
                  </>
                )}
                {pageNumbers.map(pageNumber => (
                  <button
                    key={pageNumber}
                    className={pageNumber === currentPage ? 'is-active' : ''}
                    onClick={() => this.setCurrentPageParams(pageNumber)}
                    aria-current={pageNumber === currentPage ? 'page' : undefined}
                  >
                    {pageNumber}
                  </button>
                ))}
                {pageEnd < pageCount && (
                  <>
                    {pageEnd < pageCount - 1 && <span>…</span>}
                    <button onClick={() => this.setCurrentPageParams(pageCount)}>{pageCount}</button>
                  </>
                )}
                <button
                  className="is-arrow"
                  disabled={currentPage >= pageCount}
                  onClick={() => this.setCurrentPageParams(currentPage + 1)}
                  aria-label="Next page"
                >
                  ›
                </button>
              </div>
            </nav>
          )}
        </div>
        {this.renderSummary()}
      </div>
    );
  }
}
